import { E_HundiPojo } from './E-Hundi.pojo';
import { UserTransactionHistoryPojo } from './UserTransactionHistoryPojo';

export class DummyHundiTransactionPojo{
     hundiDetail = new E_HundiPojo();
	transaction = new UserTransactionHistoryPojo();
}